import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import DonutCustomLegend from '../../../components/ApexCharts/CustomLegends/DonutCustomLegend';
import DonutChart from '../../../components/ApexCharts/DonutChart';
import Button from '../../../components/Button';
import IconButton from '../../../components/IconButton';
import { TOTAL_REWARDS_ROUTE } from '../../../routes/types';

export type TotalRewardsHalfProps = React.PropsWithChildren<{
  dataCompanyContributions: any;
}>;

const TotalRewardsHalf = ({
  dataCompanyContributions,
}: TotalRewardsHalfProps) => {
  const navigate = useNavigate();
  const [showTotalRewardsChart, setShowTotalRewardsChart] = useState(false);

  const toggleChart = () => {
    setShowTotalRewardsChart(!showTotalRewardsChart);
  };

  return (
    <Row className="m-0 p-0 d-flex justify-content-between">
      <Row className={'m-0 p-0'}>
        <Col
          className={
            'p-0 d-flex justify-content-between align-items-center mb-10'
          }
        >
          <h4 className={'text-sm-20-lg-32 m-0 lh-xs'}>{'Total Rewards'}</h4>

          <div className="d-flex flex-row">
            <IconButton
              variant="icon-emphasized"
              icon={light('chart-pie')}
              className="me-7"
              onClick={toggleChart}
            />
            <Button
              variant="primary-outline"
              rightIcon={light('chevron-right')}
              size="sm"
              onClick={() => navigate(TOTAL_REWARDS_ROUTE)}
              className="align-self-center"
            >
              Details
            </Button>
          </div>
        </Col>
      </Row>

      <Row className={'m-0 p-0'}>
        <Col className="p-0 border rounded-1 p-11">
          <Row className="m-0 px-lg-0 px-7 flex-column align-items-center">
            {showTotalRewardsChart && (
              <Col className="d-flex justify-content-center">
                <DonutChart
                  series={dataCompanyContributions.series}
                  options={dataCompanyContributions}
                />
              </Col>
            )}

            <Col className="p-0 lh-xs">
              <DonutCustomLegend options={dataCompanyContributions} />
            </Col>
          </Row>
        </Col>
      </Row>
    </Row>
  );
};

export default TotalRewardsHalf;
